import axios from 'axios';

const URL = 'https://api.openweathermap.org/data/2.5/forecast';
const API_KEY = 'ad996ab6f5b29b063a5c9bc702f7aac5';

export const fetchForecast = async (query) => {
    const { data } = await axios.get(URL, {
        params: {
            q: query,
            units: 'metric',
            APPID: API_KEY,
        }
    });

    return data;
}